import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { sessionAuthFeature } from '../store/reducers/session-auth.reducer';

/**
 * A guard that waits for a session token to be present in the store.
 * It's designed for native app integration where the token might be provided asynchronously
 *
 * It filters the token stream until a non-null value is emitted, then allows activation.
 */
export const waitForTokenGuard: CanActivateFn = (): Observable<boolean> => {
  const store = inject(Store);

  return store.pipe(
    select(sessionAuthFeature.selectToken),
    filter((token) => token != null), // Wait until the token is not null
    take(1), // Take the first non-null value and complete
    map(() => true), // Allow access
  );
};
